import type { FC } from "react";

import { ActionBar } from "../../../../../components/ActionBar/ActionBar";
import { CSVImportButton } from "../../../../../components/FeatureButtons/CSVImportButton";
import { ResourceName } from "../../../../../core/router/config/ResourceName";

export const ComplTrxImportEditForm: FC = () => {
    return (
        <ActionBar className="left">
            <CSVImportButton resourceName={ResourceName.COMPL_TRX_IMPORT} isDisabled={false} />
        </ActionBar>
    );
};
